"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LabelMixin = require("../../mixins/components/LabelMixin");
var StyledLabel = /*#__PURE__*/_styledComponents.default.label.withConfig({
  displayName: "StyledLabel",
  componentId: "c11n-8-107-0__sc-14wqmdp-0"
})(["", ""], _LabelMixin.LabelMixin);
exports.StyledLabel = StyledLabel;